import Box from "@material-ui/core/esm/Box";
import Paper from "@material-ui/core/esm/Paper";
import Skeleton from "@material-ui/lab/esm/Skeleton";
import React from 'react';
import useStyles from '../CustomersStyle';
export default function CustomerSkeleton() {
  const {
    skeleton,
    icon,
    box
  } = useStyles();
  return /*#__PURE__*/React.createElement(Paper, {
    variant: "outlined",
    className: skeleton
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "circle",
    width: 70,
    height: 70,
    className: icon
  }), /*#__PURE__*/React.createElement(Box, {
    className: box
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    width: 160,
    height: 32
  }), /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    width: 180,
    height: 22
  }), /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    width: 180,
    height: 22
  })));
}